// extracted by mini-css-extract-plugin
module.exports = {"slider":"CustomSlider_slider__1Pq4x","slick-next":"CustomSlider_slick-next__2PBQi"};